// src/config.js
// ─────────────────────────────────────────────────────────────────
// ONE PLACE to configure your backend URL.
//
// Option A (recommended): Set in your .env file:
//   REACT_APP_API_URL=https://yourdomain.com/quotationB.php
//
// Option B: Hardcode it directly below (overrides .env):
//   const HARDCODED_URL = 'https://yourdomain.com/quotationB.php';
// ─────────────────────────────────────────────────────────────────

const HARDCODED_URL = 'https://www.bestwebdealers.com/reactManager/'; // ← paste your URL here if not using .env

const API_URL =
  HARDCODED_URL ||
  process.env.REACT_APP_API_URL ||
  '/quotationB.php'; // fallback: same domain

export default API_URL;
